// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .p-ripple {
    opacity: 0;
} */

.p-tabview .p-tabview-nav li {
  margin-left: 5px !important;
}

.p-tabview .p-tabview-nav {
  position: absolute;
  z-index: 1;
}

.p-tabview .p-tabview-nav li {
  margin-left: -15px !important;
  padding: 0px 15px 0px 15px;
  position: relative;
  /* bottom: 2px; */
  top: 6px;
  margin-right: -4px !important;

  &:first-child {
    bottom: 0.04rem;
  }
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  font-size: 12px !important;
  background-color: #ffe600;
  font-weight: 400;
  color: #212529 !important;
  border: none !important;
  /* border: 1px solid #ffe600 !important; */
}
/* p-table table tbody tr td:nth-child(4) select,
p-table table tbody tr td:nth-child(2) select {
  display: none;
} */

.btn-like-link {
  background-color: #6495ed;
}
.rightbtns {
  position: relative;
  left: 10px;
  .gobackbtn {
    padding: 10px 24px;
    border-top-right-radius: 3px !important;
    border-top-left-radius: 3px !important;
  }
  .savebtn {
    padding: 10px 30px;
    border-top-right-radius: 3px !important;
    border-top-left-radius: 3px !important;
  }
}
.initialgrid {
  border-bottom: none !important;
  overflow: hidden;
  .p-datatable-thead th:nth-child(5) {
    width: 37.5%;
  }
  .p-datatable-thead th:nth-child(6) {
    width: 28.5%;
  }
}

.bsgrid {
  .p-datatable-thead th:nth-child(6) {
    width: 36% !important;
  }
}
.firstgrid {
  border-bottom: none !important;
}
.secondgrid {
  .firsttb {
    .p-datatable-thead th:nth-child(5) {
      padding-right: 62px !important;
    }
  }
  .p-datatable-thead th:nth-child(5) {
    padding-right: 42px !important;
  }
}
.p-datatable .p-datatable-tbody > tr > td:nth-child(6) {
  padding-right: 10px !important;
}
.secondgrid {
  border-left: 1px solid black !important;
  border-right: 1px solid black !important;
  border-bottom: 1px solid black !important;
  border-top: none !important;
  .secondtb {
    .fa-times {
      color: #ff0000;
    }
    select {
      margin-top: 1px;
    }
  }
  .p-datatable .p-datatable-thead > tr > th:nth-child(1),
  .p-datatable .p-datatable-thead > tr > th:nth-child(2),
  .p-datatable .p-datatable-thead > tr > th:nth-child(3),
  .p-datatable .p-datatable-thead > tr > th:nth-child(4),
  .p-datatable .p-datatable-thead > tr > th:nth-child(6) {
    visibility: hidden;
  }
  .p-datatable-tbody > tr:nth-child(odd) {
    background: #fff !important;
  }
  .p-datatable-tbody > tr:nth-child(even) {
    background: #f5f5f5 !important;
  }
  .p-datatable-thead th {
    background: #fff !important;
  }
}
.tablegrid {
  margin-left: 15px;
}
.tablegridplsection {
  .maximize-button {
    .secondgrid {
      background: #fff;
    }
  }
}
.minimized {
  .maximize-button {
    right: -12px !important;
    position: absolute;
    top: 21px;
    z-index: 1;
    background: none;
    border: none;
    font-size: 20px;
  }
}
.maximized {
  .maximize-button {
    z-index: 10000;
    position: absolute;
    right: 1px !important;
    top: 21px;
    background: none;
    border: none;
    font-size: 20px;
  }
  .PadLNull {
    padding-right: 0;
  }
  background: #fff;
}
.tablegridbssection {
  .maximize-button {
    .secondgrid {
      background: #fff;
    }
  }
  .full {
    overflow: hidden;
  }
}
.maximized {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
  overflow: auto;
  margin-left: 1px !important;
  .PadLNull {
    overflow: visible;
    width: 100%;
    /* max-width: 100% !important; */
  }
  .secondgrid {
    background: #fff;
  }
  .rightbtnsbtm {
    margin-bottom: 30px !important;
  }
}

.minimized {
  height: 50%;
  position: relative;
  z-index: 1;
}
.maximized {
  .modify {
    display: none;
  }
  .modifybtn {
    display: none;
  }
}
.minimized {
  .maxintable {
    left: -15px !important;
    top: 100px !important;
  }
}
.maximized {
  .maxintable {
    right: 30px !important;
    top: 100px !important;
  }
}

.minimized {
  .maxintablebs {
    margin-top: 77px !important;
    margin-right: 33.5% !important;
  }
}

.maximized {
  .maxintablebs {
    right: 30px !important;
    top: 97px !important;
  }
}
.addstdbtn {
  border-radius: 10px !important;
  padding: 5px;
  width: 50%;
  font-size: 16px !important;
  color: black;
  background-color: #ccc;

  &:focus {
    background-color: #ffe600 !important;
    box-shadow: none;
  }
}

#inputIdPl {
  border-color: red !important;
}

#inputIdBs {
  border-color: red !important;
}
.cancelbtn {
  background-color: #dedede !important;
  border: 1px solid #ccc!important;
}

.yesbtn{
  background-color: #ffe600 !important;
  border: 1px solid #ffe600 !important;
}
.popUpCancel {
  width: 400px !important;
}
.dropdownlabelfont{
  color: black;
  font-size: 16px;
  font-weight: 100;
  margin-top: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
